import { h } from "preact";
import {IconViewFrame, IconViewRoom, Logo, IconSearch} from './Icons';
import {VisualizerImageCard} from './Cards';

export const VisualizerFooter = (p) => {
  return <div className="visualizer-contact">
    <span dangerouslySetInnerHTML={{__html: p.visualizerData.title_description }}></span>
  </div>
}

export const VisualizerModal = (p) => {
  let modalOptions = p.visualizer_modal,
  isActive = !p.$this.state.flowSelected ? true : false,
  isExit = p.$this.state.exitIntent ? true : false;

  const handleClick = (p, option) => {
    p.$this.loadFlow(modalOptions[option].flow);
    const artWorkSection = document.querySelector('[data-section="artwork"]');
    artWorkSection && artWorkSection.click();
    option === 'getty' ? p.$this.searchImage() : p.$this.uploadImage();
  }

  return <div className={`visualizer-modal-container ${isActive || isExit ? 'active' :''}`}>
    <div className={isExit ? "visualizer-modal-exit" : "visualizer-modal"}>
      <div className="visualizer-modal-close"
        onClick={(e)=> {
          isExit ? p.$this.setState({exitIntent: false, exit: undefined }) : p.$this.loadFlow('full')
        }}>
      </div>
      <h2>{ isExit ? "Are you sure you want to exit?" : "Select Artwork Type"}</h2>
      {isExit ? ([
          <p>If you exit now your project will not be saved.</p>,
          <button className="btn button--lg" onClick={(e)=> {p.$this.setState({exitIntent: false, exit: undefined })}}>Cancel</button>,
          <a href={p.$this.state.exit}>Exit and Delete Project</a>,
      ]): (
        <div class="visualizer-modal-content">
          { Object.keys(modalOptions).map((option) => (
            <div class="visualizer-modal-column">
              <img onClick={(e) => handleClick(p, option)} src={modalOptions[option].image} />
              <h5>{ modalOptions[option].title }</h5>
              <p>{ modalOptions[option].description }</p>
              <button className={'btn button-secondary'} onClick={(e) => handleClick(p, option)}>Select</button>
            </div>
          ))}
        </div>
      )}
      </div>
  </div>
}

export const VisualizerGettyModal = (p) => {
  let isActive = p.$this.state.gLoaded ? true : false,
  isSelected = p.$this.state.imageSelected ? true : false,
  imageData = p.$this.state.images,
  selectedImage = p.$this.state.selectedImage;

  return <div className={`visualizer-modal-container ${isActive ? 'active' :''}`}>
    <div class="visualizer-modal-images">
      <div className="visualizer-modal-close" onClick={(e)=> {p.$this.setState({gLoaded: false})}}></div>
      <div className="visualizer-search-container">
        <form onSubmit={(e)=> {e.preventDefault(); p.$this.searchImage(e)}} data-page="1" class="visualizer-search">
          <IconSearch />
          <input type="text" name="search" placeholder="Search Getty Images"/>
          <div className="visualizer-search-category">
            <input type="radio" onClick={(e) => {p.$this.searchImage(e)}} name="category" id="best_seller" value="" defaultChecked/>
            <label htmlFor="best_seller">Best Sellers</label>
            <input type="radio" onClick={(e) => {p.$this.searchImage(e)}} name="category" id="photography" value="photography"/>
            <label htmlFor="photography">Photography</label>
            <input type="radio" onClick={(e) => {p.$this.searchImage(e)}} name="category" id="fine_art" value="fine_art"/>
            <label htmlFor="fine_art">Fine Art</label>
            <input type="radio" onClick={(e) => {p.$this.searchImage(e)}} name="category" id="illustration" value="illustration"/>
            <label htmlFor="illustration">Illustration</label>
            <input type="radio" onClick={(e) => {p.$this.searchImage(e)}} name="category" id="vector" value="vector"/>
            <label htmlFor="vector">Vector</label>
          </div>
          <button className="button button--lg" type="submit">Search</button>
        </form>
      </div>
      <div class="images">
        { imageData && imageData.map((image, i) =>
          <VisualizerImageCard
            data={image}
            $this={p.$this}/>
        )}
        <div className="load-more-container">
          <button className="button-secondary button button--lg load-more" onClick={(e) => {p.$this.searchImage(e, true)}}>Load More</button>
        </div>
      </div>
      <div className={`visualizer-modal-selected ${isSelected ? 'open' :''}`}>
        <div 
          className="visualizer-selector-return"
          onClick={(e)=>{p.$this.setState({imageSelected: false})}}
          ><span className="arrow-left"></span>
        </div>
        { selectedImage && <img src={selectedImage.display_sizes[0].uri} alt={selectedImage.title}/>}
        <div className="content">
          { selectedImage && <h4>{ selectedImage.title }</h4> }
          <p className="price">$35 - $95</p>
          { selectedImage && <p className="artist">By { selectedImage.artist }</p> }
          { selectedImage && <p>{ selectedImage.caption }</p>}
          <button className="button button--lg" onClick={(e)=> {p.$this.setImage(selectedImage, 'getty')}}>Select This Image</button>
        </div>
      </div>
    </div>
  </div>
}

export const VisualizerHeader = (p) => {
  return <div className="visualizer-selector-navigation">
    <div class="visualizer-return"></div>
    <a onClick={(e) => {p.$this.exit('/')}}>
      <Logo />
    </a>
    <button
      onClick={(e) => {p.$this.exit()}}
      type="submit"
      className="visualizer-close"
      ></button>
  </div>
}

export const VisualizerErrors = (t) => {
  let errors = t.state.errors,
  errorCount = 0;
  errors && Object.keys(errors).map((error) => (
    errors[error] && errorCount++
  ));
  if (!errorCount > 0) return;

  return <div className="visualizer-selector-error">
    <p>Oops! The image dimensions you picked don't work with your previously selected item{errorCount ? 's' : ''}. Please select a new option below.</p>
  </div>
}

export const VisualizerViewToggle = (d) => {
  return <div className="visualizer-toggle-container">
    <div onClick={(e) => {d.toggleState('view', 'frame')}} className={`visualizer-toggle ${d.state.view == "frame" && 'selected'}`}>
      <IconViewFrame />
    </div>
    <div onClick={(e) => {d.toggleState('view', 'room')}} className={`visualizer-toggle ${d.state.view == "room" && 'selected'}`}>
      <IconViewRoom />
    </div>
  </div>
}

export const VisualizerATC = (d) => {
  let $this = d.$this,
  data = $this.state,
  flow = $this.state.flow,
  selectedItems = data.selectedItems,
  items = data.selectedItem && data.selectedItem[data.activePanel] && Object.keys(data.selectedItem[data.activePanel]).length,
  panelData = data.panelData[data.activePanel] && data.panelData[data.activePanel],
  options = panelData && (data.activePanel !== 'printing' && data.activePanel !== 'frame') ? Object.keys(panelData).length : 1,
  isSelected = selectedItems[data.activePanel] && Object.keys(selectedItems[data.activePanel]) === options,
  isDisabled = !(options === items || isSelected || !panelData),
  isComplete = true,
  sections = flow !== 'full' ? d.visualizer_sections[flow] : d.visualizer_sections;

  // Matting - Business Requirements
  let sMatting = $this.state.selectedItem && $this.state.selectedItem['matting'] && $this.state.selectedItem['matting'].type,
  mExcluded = (data.activePanel === 'matting' ? (sMatting ? (sMatting.includes('NO MAT') || sMatting.includes('MOUNTED')) : false) : false);
  isDisabled = !mExcluded ? isDisabled : false;

  // Check Step Completion
  Object.keys(sections).map((section) => {
    let id = sections[section].id;
    id && (isComplete = selectedItems[id] ? isComplete : false);
    
    !id && !mExcluded && Object.keys(sections[section]).map((item) => {
      id = sections[section][item].id;
      isComplete = (selectedItems[id] || selectedItems[id] > -1) ? isComplete : false;
    })
  });

  return (
    <div className="visualizer-selector-atc">
      <span className="price">$<span>{ data.price }</span></span>
      <button onClick={(e) => {$this.createProduct()}} className="add-to-bag btn button--lg" disabled={!isComplete}>Add To Bag</button>
      <button 
        onClick={(e) => {$this.addOption(e)}} 
        className="apply btn button--lg"
        disabled={isDisabled}
        >Select</button>
    </div>
  )
}